import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useOrg } from '../org/OrgContext';

export default function Login() {
  const { api, login } = useAuth();
  const { setOrg } = useOrg();
  const nav = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw]     = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (loading) return;
    setError('');
    setLoading(true);

    try {
      const { data } = await api.post('/auth/login', { username, password });
      login(data);

      const perms   = Array.isArray(data?.user?.permissions) ? data.user.permissions : [];
      const allowed = ['GFM', 'GPM', 'Fleet'].filter(p => perms.includes(p));

      if (allowed.length === 1) {
        setOrg(allowed[0]);
        localStorage.setItem('org', allowed[0]);
        nav('/dashboard', { replace: true });
      } else {
        nav('/choose', { replace: true });
      }
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        (err?.response?.status === 401 ? 'Invalid credentials' : '') ||
        'Login failed';
      setError(msg);
    } finally {
      setLoading(false);
    }
  }

  const brandName = process.env.REACT_APP_BRAND_NAME || 'Gateway';

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <img className="login-brand-logo" src="/GFMLogo.ico" alt="" />
          <h1>{brandName}</h1>
          <p>Sign in to your account</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label htmlFor="login-username">Username</label>
            <input
              id="login-username"
              className="input"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              autoComplete="username"
            />
          </div>

          <div className="login-field">
            <label htmlFor="login-password">Password</label>
            <div className="pw-wrap">
              <input
                id="login-password"
                className="input"
                type={showPw ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
                onKeyDown={e => { if (e.key === 'Enter') handleSubmit(e); }}
              />
              <button
                type="button"
                className="btn ghost small pw-toggle"
                onClick={() => setShowPw(s => !s)}
                aria-label={showPw ? 'Hide password' : 'Show password'}
              >
                {showPw ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          {error && <div className="alert error">{error}</div>}

          <button
            className="btn login-submit"
            disabled={loading || !username || !password}
          >
            {loading ? 'Signing in' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
